/**
 * @file settings-sections.ts
 * @description Разделы панели «Настройки сайта» (phase19.16 Р1; SC56;
 * uiux-design-r1 §4): реестр подписей (OCP — новый раздел = строка) и
 * разбор ключа из адреса `?section=`. phase19.16 SB138 — раздел «Доступ к
 * сайту» (`access`, адрес `/shop/<slug>/site/builder?panel=settings.access`).
 */

export type SiteSettingsSectionKey = "brand" | "contacts" | "socials" | "footer" | "seller" | "access";

export const SITE_SETTINGS_SECTION_LABELS: Readonly<Record<SiteSettingsSectionKey, string>> = {
  brand: "Бренд",
  contacts: "Контакты",
  socials: "Соцсети",
  footer: "Подвал",
  seller: "Продавец",
  // SB138: пауза сайта «Сайт закрыт на работы» — пульт сайта рядом с брендом и продавцом.
  access: "Доступ к сайту",
};

export const SITE_SETTINGS_SECTIONS = Object.keys(SITE_SETTINGS_SECTION_LABELS) as SiteSettingsSectionKey[];

/** Ключ раздела из адреса; неизвестный — `null`. */
export function asSettingsSection(value: string | null): SiteSettingsSectionKey | null {
  return value !== null && (SITE_SETTINGS_SECTIONS as string[]).includes(value) ? (value as SiteSettingsSectionKey) : null;
}
